var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"dark":""}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){_vm.$root.sidebar = true}}}),_c('v-toolbar-title',[_vm._v("Admin panel")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }